import styled, { css } from 'styled-components';
import error from 'assets/error.png';

const ErrorNoti = ({ padding, marginTop, errorMsg, ...rest }) => {
  return (
    <ErrorNotiBlock padding={padding} marginTop={marginTop} {...rest}>
      <img src={error} alt="error" />
      <div>{errorMsg ? errorMsg : '서버 오류가 발생했습니다'}</div>
    </ErrorNotiBlock>
  );
};

export default ErrorNoti;

const ErrorNotiBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  position: relative;

  img {
    width: 600px;
  }

  ${props =>
    props.marginTop &&
    css`
      margin-top: 3rem;
    `}

  ${props =>
    props.padding &&
    css`
      padding-bottom: 2rem;
    `}
`;
